export default __webpack_public_path__ + "static/media/icon_yhteenveto_summary.6fbfb9f6.svg";